import { ArrowDown, ArrowUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface ScrollCTAProps {
  position: "top" | "bottom";
  onClick: () => void;
  className?: string;
}

export function ScrollCTA({ position, onClick, className }: ScrollCTAProps) {
  const Icon = position === "top" ? ArrowUp : ArrowDown;
  const text =
    position === "top" ? "Go to previous highlight" : "Go to next highlight";

  return (
    <div
      className={cn(
        "absolute left-1/2 -translate-x-1/2 z-20 px-3 py-1.5 rounded-full shadow-lg bg-background border border-border flex items-center",
        position === "top" ? "top-2" : "bottom-2",
        className,
      )}
    >
      <Button
        variant="ghost"
        size="sm"
        onClick={onClick}
        className="h-auto p-0 text-xs hover:bg-transparent"
      >
        <Icon className="h-3 w-3 mr-1.5" />
        {text}
      </Button>
    </div>
  );
}
